import { clone } from "@/util/libUtil.js"

import defaultAtencionForm from "./defaultAtencionForm";
import defaultNoInterestForm from "./defaultNoInterestForm";

let defaultAtencionNoInterestForm = clone(defaultAtencionForm)
defaultAtencionNoInterestForm.no_interesado = clone(defaultNoInterestForm)

export default defaultAtencionNoInterestForm